import store from '@/store';
import { isEmpty } from '@/common/utils/Util';
import { showTextModal } from '@/common/utils/ModalState';
import ServiceExec from '@/common/utils/ServiceExec';
import { businessUser } from '@/common/service/apiList';

const requireMembership = async (to, from) => {
  await store.dispatch('common/fetchFeatureFlags', { force: true });
  const enabled = store.getters['common/getFeatureFlags']?.businessMembershipEnabled === true;
  if (!enabled) {
    showTextModal('디지털 멤버십은 현재 준비 중이에요.', '확인');
    return from?.name ? false : '/intro';
  }
  const user = store.getters['user/getUserData'];
  if (isEmpty(user?.userNo)) {
    store.commit('layout/setLoginMovePath', to.fullPath);
    return '/signin';
  }
};

const requireOwnerMembership = async (to, from) => {
  const blocked = await requireMembership(to, from);
  if (blocked !== undefined) return blocked;

  const businessNo = Number(to.params.businessNo);
  if (!Number.isSafeInteger(businessNo) || businessNo <= 0) return '/intro';

  const { status: businessStatus, data: businessData } = (await ServiceExec.get(
    businessUser.getMyBusinessList,
    { page: 1, limit: 100, isOneKm: false }
  )) || {};
  const ownedBusiness = businessStatus === ServiceExec.status.OK
    ? (businessData?.list || []).find(item => Number(item.businessNo) === businessNo)
    : null;
  if (!ownedBusiness) {
    showTextModal('본인 사업장의 멤버십만 관리할 수 있어요.', '확인');
    return from?.name ? false : '/intro';
  }
  if (ownedBusiness.authenticateStatus && ownedBusiness.authenticateStatus !== 'SUCCESS') {
    showTextModal('사업장 승인이 완료된 후 멤버십을 열 수 있어요.', '확인');
    return from?.name ? false : '/intro';
  }

  // 260918 대표 회의 ①: 간판 존재 게이트 폐지(상시 ON) — 승인 SUCCESS 본인 사업장이면 통과
};

export default [
  {
    path: '/membership',
    name: 'membership-wallet',
    component: () => import('@/views/membership/MembershipWallet.vue'),
    meta: { isHeader: true, isNav: false, isBack: true, isHome: true, titleName: '멤버십' },
    beforeEnter: requireMembership
  },
  {
    path: '/membership/join/:code',
    name: 'membership-join',
    component: () => import('@/views/membership/MembershipJoin.vue'),
    meta: { isHeader: true, isNav: false, isBack: true, titleName: '멤버십 가입' },
    beforeEnter: requireMembership
  },
  {
    path: '/membership/:businessNo',
    name: 'membership-detail',
    component: () => import('@/views/membership/MembershipDetail.vue'),
    meta: { isHeader: true, isNav: false, isBack: true, isHome: true, titleName: '멤버십 상세' },
    beforeEnter: requireMembership
  },
  {
    path: '/business/membership/:businessNo',
    name: 'business-membership-manage',
    component: () => import('@/views/business/membership/BusinessMembershipManage.vue'),
    meta: { isHeader: true, isNav: false, isBack: true, isHome: true, titleName: '단골 관리' },
    beforeEnter: requireOwnerMembership
  }
];
